var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_11451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.466,44.789H8.535c-3.337,0-6.042-2.706-6.042-6.042s2.706-6.042,6.042-6.042h132.931c3.339,0,6.042,2.706,6.042,6.042 S144.805,44.789,141.466,44.789z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_11452"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.466,81.042H8.536c-3.337,0-6.043-2.702-6.043-6.042c0-3.337,2.706-6.042,6.043-6.042h132.93 c3.339,0,6.042,2.706,6.042,6.042C147.508,78.34,144.805,81.042,141.466,81.042z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path_11453"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.466,117.296H8.535c-3.337,0-6.042-2.701-6.042-6.043c0-3.34,2.705-6.041,6.042-6.041h132.931 c3.339,0,6.042,2.701,6.042,6.041C147.508,114.595,144.805,117.296,141.466,117.296z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.861f0897ca2ee3be7f04722297656b8f.svg";
export { ForwardRef as ReactComponent };